export const LogoMark = ({ className = "h-8 w-8" }) => (
  <svg
    viewBox="0 0 44 44"
    fill="none"
    stroke="currentColor"
    strokeWidth="8.5"
    strokeLinecap="round"
    className={className}
    aria-hidden="true"
  >
    <path d="M11 40V13" />
    <circle cx="23.5" cy="18" r="10.5" />
  </svg>
);

export const Logo = ({ className = "", markClassName = "h-7 w-7", testId }) => (
  <span className={`inline-flex items-center gap-2.5 ${className}`} data-testid={testId}>
    <LogoMark className={markClassName} />
    <span className="font-display text-xl font-extrabold lowercase tracking-tight">pepmuse</span>
  </span>
);
